module.exports = __webpack_public_path__ + "img/78ne.d824ccd8.svg";